import * as React from 'react'

import {
  Box,
  TagColor as Color,
  Icon,
  Text,
  Tooltip,
  useToggle,
} from '@factorialco/deprecated-design-system'
import { ApprovalGroupDetailsFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { RuleCard } from '../RuleCard'

interface TooltipProps {
  label: string
}

const InformationTooltip = ({ label }: TooltipProps) => {
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip.Alt attachment="bottom center" open={open} toggle={toggle} label={label}>
      <Icon.Medium icon="info-circle-line" />
    </Tooltip.Alt>
  )
}

interface Props {
  ruleName: string | undefined
  rulesConfigurationId: string | undefined
  group: ApprovalGroupDetailsFragment
}

export const IfRulesNotMet = ({ ruleName, rulesConfigurationId, group }: Props) => {
  const defaultFlow = group?.flows.find((groupFlow) => groupFlow.default)

  const rulesIndex = rulesConfigurationId ? 1 : 2

  return (
    <Box>
      <Box paddingTop="s16" flexDirection="row" alignItems="center" gap="s8">
        <Text.Normal size="200" weight="medium" color="grey800">
          {i18n.t('settings.approvals.approval_rule.configuration.if_not_rules')}
        </Text.Normal>
        <InformationTooltip
          label={i18n.t('settings.approvals.approval_rule.configuration.if_not_tooltip')}
        />
      </Box>
      <Box paddingTop="s8" gap="s0">
        {!rulesConfigurationId && (
          <RuleCard
            flow={null}
            title={ruleName}
            index={1}
            tagLabel={i18n.t('settings.approvals.approval_rule.current')}
            tagType={Color.grey5}
            empty
          />
        )}
        {group.rulesConfiguration?.map((rule, index) => (
          <RuleCard
            group={group}
            index={index + rulesIndex}
            key={rule.id}
            flow={rule.flow}
            title={String(rule.id) === rulesConfigurationId ? ruleName : rule.name}
            description={rule.description}
            decision={rule.onRulesMet}
            tagLabel={
              String(rule.id) === rulesConfigurationId
                ? i18n.t('settings.approvals.approval_rule.current')
                : undefined
            }
            tagType={Color.grey5}
          />
        ))}
        <RuleCard
          flow={defaultFlow}
          title={defaultFlow?.name}
          index={group.rulesConfiguration.length + rulesIndex}
          tagLabel={i18n.t('settings.approvals.detail.default_tag')}
        />
      </Box>
    </Box>
  )
}
